import {
  isLoopbackHostname,
  normalizeAuthActionLink,
  normalizeLoopbackUrl,
} from "../../supabase/functions/_shared/auth-action-link";

export { isLoopbackHostname, normalizeAuthActionLink, normalizeLoopbackUrl };

/** In local dev, keep the Hub on localhost when GoTrue redirects to 127.0.0.1. */
export function redirectLoopbackToPreferredHost(): boolean {
  if (typeof window === "undefined" || !import.meta.env.DEV) {
    return false;
  }

  const { hostname, href } = window.location;
  if (hostname !== "127.0.0.1") {
    return false;
  }

  const url = new URL(href);
  url.hostname = "localhost";
  window.location.replace(url.toString());
  return true;
}
